<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Totes</li>
    </ol>
  </nav>
  <div class="row align-items-center">
    <div class="col mt-md-0 text-right float-right" style="Height:34px;">
      <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              class="btn btn-outline-primary btn-sm dropdown-toggle ml-2 d-none-mobile" *ngIf="checkedList?.length === 1">
        Actions
      </button>
      <div class="dropdown-menu dropdown-menu2  dropdown-menu-right ml-3" *ngIf="(checkedList?.length)">
        <!--<a (click)="commonPrintPopUp(toteList,'QRCode')" class="dropdown-item file btn shift-import">Print QR Codes</a>
        <a (click)="commonPrintPopUp(toteList, 'Barcode')" class="dropdown-item file btn shift-import">Print Barcodes</a>-->
        <a (click)="commonPrintPopUp()" class="dropdown-item file btn shift-import">Print</a>
      </div>
      <a placement="bottom" ngbTooltip="Create" class="ml-3">
        <svg xmlns="http://www.w3.org/2000/svg" routerLink="/admin/createTote" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z" transform="translate(2.823 3.938)"/></g></svg>
      </a>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block " [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th><!--<div class="form-checkbox">
                              <input type="checkbox" id="all_items" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()"/>
                              <label for="all_items"></label>
                            </div>--></th>
            <th>Tote Number</th>
            <th>Tote Name</th>
            <th>Tote Type</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let t of toteList">
            <td>
              <div class="form-checkbox">
                <input type="checkbox" id="{{t.toteId}}" [(ngModel)]="t.isSelected" name="list_name"
                       (change)="selectShip(t)">
                <label for="{{t.toteId}}"></label></div>
            </td>
            <td>{{t.toteId}}</td>
            <td style="text-transform:capitalize;">{{t.toteName}}</td>
            <td>{{t.toteType}}</td>
            <td>
              <div class="toggle-2">
                <input type="checkbox" name="onoffswitch" id="customSwitch_{{t.toteId}}" class="custom-control-input"
                       (click)="changeStatus(t)" [checked]="t.status==='ACTIVE'" class="checkbox"/>
                <label for="customSwitch_{{t.toteId}}" class="toggle">
                  <span>ON</span><span>OFF</span>
                </label>
              </div>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="toteList?.length===0|| !toteList?.length">
            <td colspan="4" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none">
        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <!--                <th ><div class="form-checkbox">
              <input type="checkbox" id="all_items" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()"/>
              <label for="all_items"></label>
            </div></th>-->
            <th>Tote Number</th>
            <th>Tote Name</th>
            <th>Tote Type</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let t of toteList">
            <!-- <td><div class="form-checkbox">
<input type="checkbox" id="{{ao.id}}" [(ngModel)]="ao.isSelected" name="list_name" (change)="selectAOwner(ao)">
<label for="{{ao.id}}"></label></div></td>-->
            <td><b class=" tablesaw-cell-label">Tote Number</b>
              <span class="tablesaw-cell-content">{{t.toteId}}</span></td>
            <td><b class=" tablesaw-cell-label">Tote Name</b>
              <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{t.toteName}}</span></td>
            <td><b class=" tablesaw-cell-label">Tote Type</b>
              <span class="tablesaw-cell-content">{{t.toteType}}</span></td>
            <td><b class=" tablesaw-cell-label">Status</b>
              <span class="tablesaw-cell-content">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" (click)="changeStatus(t)"
                       id="customSwitch2_{{t.toteId}}" [checked]="t.status==='ACTIVE'">
                <label class="custom-control-label" for="customSwitch2_{{t.toteId}}"> </label>
              </div>
              </span></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<!--CommonPage-->
<div [ngStyle]="{'display': commonPage =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': commonPage == 'Y'}" class="modal" id="commonPage" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="commonPage">Selected Totes</h5>
        <button type="button" class="close" (click)="clear()">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">

              <div calss="row">
                <div calss="col-md-4 required">
                  <label  id="qRCodeAndBarCode" class="control-label" for="noOfLabels">No of Copies</label>
                  <div class="form-group required">
                    <input type="text" id="noOfLabels" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                           [(ngModel)]="noOfLabels" id="noOfLabels" class="form-control" (blur)="noOfLabelsBlur()" [ngClass]="{'is-invalid':noOfLabelsError}"
                           [ngModelOptions]="{standalone: true}" required>
                    <div id="noOfLabelsError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!noOfLabelsError">{{noOfLabelsError}}</div>
                  </div>
                </div>
              </div>

              <div class="row">


                <div class="col-6">
                  <div class="form-group required">
                    <label class="control-label" for="printTypeCommonPage">Print Option</label>
                    <select class="form-control" id="printTypeCommonPage" [(ngModel)]="printTypes"
                            [ngModelOptions]="{standalone: true}" [ngClass]="{'is-invalid':printOptionError}" required>
                      <option>24 labels with 63mm X 34mm</option>
                      <option>33 labels with 63mm X 34mm</option>
                      <option>40 labels with 63mm X 34mm</option>
                      <option>48 labels with 63mm X 34mm</option>
                      <option>Custom</option>
                    </select>
                    <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!printOptionError">
                      {{printOptionError}}
                    </div>
                  </div>
                </div>

                <div class="col-6  mt-4 text-right">
                  <button class="btn btn-cancel" type="button" (click)="clear()">Cancel</button>
                  <button  type="submit" class="btn btn-orange ml-1"
                          (click)="printQrAndBarCode()">Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<!--display PrintPopUp-->
<!--
<div [ngStyle]="{'display': displayPopUP =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': displayPopUP == 'Y'}" class="modal" id="popUpHold" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleHoldLabel">Print QR Code</h5>
        <button type="button" class="close" (click)="closePopUp()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="row">


                &lt;!&ndash;
                                <div class="col-8" >
                                  <div class="form-group required">
                                    <label class="control-label" for="printTypes">Print Option</label>
                                    <select class="form-control" id="printTypes" [(ngModel)]="printTypes" [ngModelOptions]="{standalone: true}" [ngClass]="{'is-invalid':printOptionError}" required>
                                      <option>24 labels with 63mm X 34mm</option>
                                      <option>33 labels with 63mm X 34mm</option>
                                      <option>40 labels with 63mm X 34mm</option>
                                      <option>48 labels with 63mm X 34mm</option>
                                    </select>
                                    <div class="invalid-feedback d-block shift-invalid-login"  [hidden]="!printOptionError">{{printOptionError}}</div>
                                  </div>
                                </div>
                &ndash;&gt;

                <div class="col-12  mt-4 text-right">
                  <button class="btn btn-orange" (click)="print()">
                    <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         width="20" height="20" viewBox="0 0 60 60" version="1.1">
                      &lt;!&ndash; Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch &ndash;&gt;<title>004 -
                      Printer</title>
                      <desc>Created with Sketch.</desc>
                      <defs/>
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="004-&#45;&#45;Printer" fill="#ffff" fill-rule="nonzero">
                          <path
                            d="M59.932,23.665 C59.924,23.641 59.92,23.617 59.91,23.594 C59.8680045,23.4964667 59.8106058,23.406317 59.74,23.327 L51.228,13.964 C50.0898233,12.7143877 48.4782588,12.0015245 46.788,12 L42,12 L42,2 C42,0.8954305 41.1045695,6.76353751e-17 40,0 L20,0 C18.8954305,-6.76353751e-17 18,0.8954305 18,2 L18,12 L13.212,12 C11.5217412,12.0015245 9.91017672,12.7143877 8.772,13.964 L0.26,23.327 C0.189394179,23.406317 0.131995527,23.4964667 0.09,23.594 C0.08,23.617 0.076,23.641 0.068,23.665 C0.0350696905,23.7552934 0.0158563363,23.8500119 0.011,23.946 C0.01,23.965 0,23.981 0,24 L0,43 C0.00330737898,46.3123376 2.68766243,48.9966926 6,49 L13,49 L9.4,53.8 C8.94547353,54.4060353 8.87236159,55.2168591 9.21114562,55.8944272 C9.54992965,56.5719952 10.2424559,57 11,57 L16.81,57 L16.732,57.173 C16.4508706,57.7920313 16.5034676,58.5114847 16.8716375,59.0830478 C17.2398075,59.6546109 17.8731224,59.9999972 18.553,60 L41.447,60 C42.1268776,59.9999972 42.7601925,59.6546109 43.1283625,59.0830478 C43.4965324,58.5114847 43.5491294,57.7920313 43.268,57.173 L43.189,57 L49,57 C49.7575441,57 50.4500704,56.5719952 50.7888544,55.8944272 C51.1276384,55.2168591 51.0545265,54.4060353 50.6,53.8 L47,49 L54,49 C57.3123376,48.9966926 59.9966926,46.3123376 60,43 L60,24 C60,23.981 59.99,23.965 59.989,23.946 C59.9841437,23.8500119 59.9649303,23.7552934 59.932,23.665 Z M20,2 L40,2 L40,18 L20,18 L20,2 Z M10.252,15.31 C11.0104682,14.4764039 12.0849882,14.0008562 13.212,14 L18,14 L18,18 L17,18 C16.4477153,18 16,18.4477153 16,19 C16,19.5522847 16.4477153,20 17,20 L43,20 C43.5522847,20 44,19.5522847 44,19 C44,18.4477153 43.5522847,18 43,18 L42,18 L42,14 L46.788,14 C47.9150118,14.0008562 48.9895318,14.4764039 49.748,15.31 L56.739,23 L3.261,23 L10.252,15.31 Z M45,46.334 L43,43.667 L43,42 C43,40.3431458 41.6568542,39 40,39 L20,39 C18.3431458,39 17,40.3431458 17,42 L17,43.667 L15,46.334 L15,39 C15.0044086,35.1358343 18.1358343,32.0044086 22,32 L38,32 C41.8641657,32.0044086 44.9955914,35.1358343 45,39 L45,46.334 Z M41,43 L19,43 L19,42 C19,41.4477153 19.4477153,41 20,41 L40,41 C40.5522847,41 41,41.4477153 41,42 L41,43 Z M18.553,58 L22.644,49 L37.356,49 L41.451,58 L18.553,58 Z M42.28,55 L38.922,47.611 L38.911,47.587 C38.8642853,47.4874278 38.8010596,47.3964775 38.724,47.318 C38.703,47.296 38.679,47.279 38.657,47.259 C38.5913703,47.2010433 38.5184131,47.1519569 38.44,47.113 C38.4104343,47.0973934 38.3800579,47.0833735 38.349,47.071 C38.2378522,47.0266411 38.1196445,47.0025931 38,47 L22,47 C21.8807537,47.0023936 21.7628973,47.0261003 21.652,47.07 C21.6209421,47.0823735 21.5905657,47.0963934 21.561,47.112 C21.4825869,47.1509569 21.4096297,47.2000433 21.344,47.258 C21.322,47.278 21.298,47.295 21.277,47.317 C21.1999404,47.3954775 21.1367147,47.4864278 21.09,47.586 L21.079,47.61 L17.72,55 L11,55 L18.5,45 L41.5,45 L49,55 L42.28,55 Z M58,43 C58,45.209139 56.209139,47 54,47 L47,47 L47,39 C46.993939,34.0319499 42.9680501,30.006061 38,30 L22,30 C17.0319499,30.006061 13.006061,34.0319499 13,39 L13,47 L6,47 C3.790861,47 2,45.209139 2,43 L2,25 L58,25 L58,43 Z"
                            id="Shape"/>
                          <path
                            d="M53,34 C54.6568542,34 56,32.6568542 56,31 C56,29.3431458 54.6568542,28 53,28 C51.3431458,28 50,29.3431458 50,31 C50,32.6568542 51.3431458,34 53,34 Z M53,30 C53.5522847,30 54,30.4477153 54,31 C54,31.5522847 53.5522847,32 53,32 C52.4477153,32 52,31.5522847 52,31 C52,30.4477153 52.4477153,30 53,30 Z"
                            id="Shape"/>
                          <circle id="Oval" cx="53" cy="37" r="1"/>
                          <circle id="Oval" cx="53" cy="40" r="1"/>
                          <circle id="Oval" cx="53" cy="43" r="1"/>
                          <path
                            d="M26,53 L34,53 C34.5522847,53 35,52.5522847 35,52 C35,51.4477153 34.5522847,51 34,51 L26,51 C25.4477153,51 25,51.4477153 25,52 C25,52.5522847 25.4477153,53 26,53 Z"
                            id="Shape"/>
                          <path
                            d="M36,54 L24,54 C23.4477153,54 23,54.4477153 23,55 C23,55.5522847 23.4477153,56 24,56 L36,56 C36.5522847,56 37,55.5522847 37,55 C37,54.4477153 36.5522847,54 36,54 Z"
                            id="Shape"/>
                          <path
                            d="M5,30 C5.55228475,30 6,29.5522847 6,29 L6,28 C6,27.4477153 5.55228475,27 5,27 C4.44771525,27 4,27.4477153 4,28 L4,29 C4,29.5522847 4.44771525,30 5,30 Z"
                            id="Shape"/>
                          <path
                            d="M5,40 C5.55228475,40 6,39.5522847 6,39 L6,33 C6,32.4477153 5.55228475,32 5,32 C4.44771525,32 4,32.4477153 4,33 L4,39 C4,39.5522847 4.44771525,40 5,40 Z"
                            id="Shape"/>
                        </g>
                      </g>
                    </svg>
                    Print
                  </button>
                </div>
              </div>
              &lt;!&ndash; <div [hidden]="printTypes!=='24 labels with 63mm X 34mm'">
                 <kendo-pdf-export #pdf paperSize="A4" margin="5mm">
                   <div class="mt-2"  style="display:inline-block !important;padding: 5px 5px !important;width:63mm !important;height:34mm !important;" *ngFor="let q of checkedListView" >
                     <div class="row mx-0 align-items-center">
                       <div class="col-5 px-1">
                         <qrcode qrdata= "{{q.codeValue}}" [width]="100" [errorCorrectionLevel]="'M'"></qrcode>
                       </div>
                       <div class="col-7 pr-1" >
                         <label class="text-black"><b>Tote Id : </b>{{q.toteId}}</label>
                       </div>
                     </div>
                   </div>
                 </kendo-pdf-export>
               </div>
               <div [hidden]="printTypes !=='40 labels with 63mm X 34mm'">
                 <kendo-pdf-export #pdf paperSize="A4" margin="5mm">
                   <div class="inner-box mt-2"   style="display:inline-block !important;padding: 2mm 2mm !important;width:32.5mm !important;height:19.7mm !important;" *ngFor="let q of checkedListView" >
                     <div class="row align-items-center" style="margin-left:0px !important;margin-right:0px !important;width:32.5mm !important;height:19.7mm !important;">
                       <div class="col-5" style="padding-left:0.5em !important;padding-right:0.5em !important;">
                         <qrcode qrdata= "{{q.codeValue}}" [width]="50" [errorCorrectionLevel]="'M'"></qrcode>
                       </div>
                       <div class="col-7" style="padding-right:0.5em !important;">
                         <label class="text-black"><b>Tote Id : </b>{{q.toteId}}</label>
                       </div>
                     </div>
                   </div>
                 </kendo-pdf-export>
               </div>&ndash;&gt;

              <div class="inner-box mt-4" *ngFor="let q of checkedListView">
                <div calss="row">
                  <div calss="col">
                    <div class="row">
                      <div class="col-md-2 text-dark-right element ">
                        <qrcode qrdata="{{q.codeValue}}" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
                      </div>
                    </div>
                    <label class="text-black"><b>Tote Id : </b>{{q.toteId}}</label><br>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
-->


<!--BarCode PopUp-->
<!--
<div [ngStyle]="{'display': barCodePopUP =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': barCodePopUP == 'Y'}" class="modal" id="barcode" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel2" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-75 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleBarcode">Print BarCode</h5>
        <button type="button" class="close" (click)="closePopUpBarCode()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="">
                <div class="row">

                  &lt;!&ndash;
                                    <div class="col-8" >
                                      <div class="form-group required">
                                        <label class="control-label" for="printTypesBarCode">Print Option</label>
                                        <select class="form-control" id="printTypesBarCode" [(ngModel)]="printTypes" [ngModelOptions]="{standalone: true}" [ngClass]="{'is-invalid':printOptionError}" required>
                                          <option>24 labels with 63mm X 34mm</option>
                                          <option>33 labels with 63mm X 34mm</option>
                                          <option>40 labels with 63mm X 34mm</option>
                                          <option>48 labels with 63mm X 34mm</option>
                                        </select>
                                        <div class="invalid-feedback d-block shift-invalid-login"  [hidden]="!printOptionError">{{printOptionError}}</div>
                                      </div>
                                    </div>
                  &ndash;&gt;


                  <div class="col-12 mt-4  text-right">
                    <button class="btn btn-orange" (click)="print()">
                      <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                           width="20" height="20" viewBox="0 0 60 60" version="1.1">
                        &lt;!&ndash; Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch &ndash;&gt;<title>004 -
                        Printer</title>
                        <desc>Created with Sketch.</desc>
                        <defs/>
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="004-&#45;&#45;Printer" fill="#ffff" fill-rule="nonzero">
                            <path
                              d="M59.932,23.665 C59.924,23.641 59.92,23.617 59.91,23.594 C59.8680045,23.4964667 59.8106058,23.406317 59.74,23.327 L51.228,13.964 C50.0898233,12.7143877 48.4782588,12.0015245 46.788,12 L42,12 L42,2 C42,0.8954305 41.1045695,6.76353751e-17 40,0 L20,0 C18.8954305,-6.76353751e-17 18,0.8954305 18,2 L18,12 L13.212,12 C11.5217412,12.0015245 9.91017672,12.7143877 8.772,13.964 L0.26,23.327 C0.189394179,23.406317 0.131995527,23.4964667 0.09,23.594 C0.08,23.617 0.076,23.641 0.068,23.665 C0.0350696905,23.7552934 0.0158563363,23.8500119 0.011,23.946 C0.01,23.965 0,23.981 0,24 L0,43 C0.00330737898,46.3123376 2.68766243,48.9966926 6,49 L13,49 L9.4,53.8 C8.94547353,54.4060353 8.87236159,55.2168591 9.21114562,55.8944272 C9.54992965,56.5719952 10.2424559,57 11,57 L16.81,57 L16.732,57.173 C16.4508706,57.7920313 16.5034676,58.5114847 16.8716375,59.0830478 C17.2398075,59.6546109 17.8731224,59.9999972 18.553,60 L41.447,60 C42.1268776,59.9999972 42.7601925,59.6546109 43.1283625,59.0830478 C43.4965324,58.5114847 43.5491294,57.7920313 43.268,57.173 L43.189,57 L49,57 C49.7575441,57 50.4500704,56.5719952 50.7888544,55.8944272 C51.1276384,55.2168591 51.0545265,54.4060353 50.6,53.8 L47,49 L54,49 C57.3123376,48.9966926 59.9966926,46.3123376 60,43 L60,24 C60,23.981 59.99,23.965 59.989,23.946 C59.9841437,23.8500119 59.9649303,23.7552934 59.932,23.665 Z M20,2 L40,2 L40,18 L20,18 L20,2 Z M10.252,15.31 C11.0104682,14.4764039 12.0849882,14.0008562 13.212,14 L18,14 L18,18 L17,18 C16.4477153,18 16,18.4477153 16,19 C16,19.5522847 16.4477153,20 17,20 L43,20 C43.5522847,20 44,19.5522847 44,19 C44,18.4477153 43.5522847,18 43,18 L42,18 L42,14 L46.788,14 C47.9150118,14.0008562 48.9895318,14.4764039 49.748,15.31 L56.739,23 L3.261,23 L10.252,15.31 Z M45,46.334 L43,43.667 L43,42 C43,40.3431458 41.6568542,39 40,39 L20,39 C18.3431458,39 17,40.3431458 17,42 L17,43.667 L15,46.334 L15,39 C15.0044086,35.1358343 18.1358343,32.0044086 22,32 L38,32 C41.8641657,32.0044086 44.9955914,35.1358343 45,39 L45,46.334 Z M41,43 L19,43 L19,42 C19,41.4477153 19.4477153,41 20,41 L40,41 C40.5522847,41 41,41.4477153 41,42 L41,43 Z M18.553,58 L22.644,49 L37.356,49 L41.451,58 L18.553,58 Z M42.28,55 L38.922,47.611 L38.911,47.587 C38.8642853,47.4874278 38.8010596,47.3964775 38.724,47.318 C38.703,47.296 38.679,47.279 38.657,47.259 C38.5913703,47.2010433 38.5184131,47.1519569 38.44,47.113 C38.4104343,47.0973934 38.3800579,47.0833735 38.349,47.071 C38.2378522,47.0266411 38.1196445,47.0025931 38,47 L22,47 C21.8807537,47.0023936 21.7628973,47.0261003 21.652,47.07 C21.6209421,47.0823735 21.5905657,47.0963934 21.561,47.112 C21.4825869,47.1509569 21.4096297,47.2000433 21.344,47.258 C21.322,47.278 21.298,47.295 21.277,47.317 C21.1999404,47.3954775 21.1367147,47.4864278 21.09,47.586 L21.079,47.61 L17.72,55 L11,55 L18.5,45 L41.5,45 L49,55 L42.28,55 Z M58,43 C58,45.209139 56.209139,47 54,47 L47,47 L47,39 C46.993939,34.0319499 42.9680501,30.006061 38,30 L22,30 C17.0319499,30.006061 13.006061,34.0319499 13,39 L13,47 L6,47 C3.790861,47 2,45.209139 2,43 L2,25 L58,25 L58,43 Z"
                              id="Shape"/>
                            <path
                              d="M53,34 C54.6568542,34 56,32.6568542 56,31 C56,29.3431458 54.6568542,28 53,28 C51.3431458,28 50,29.3431458 50,31 C50,32.6568542 51.3431458,34 53,34 Z M53,30 C53.5522847,30 54,30.4477153 54,31 C54,31.5522847 53.5522847,32 53,32 C52.4477153,32 52,31.5522847 52,31 C52,30.4477153 52.4477153,30 53,30 Z"
                              id="Shape"/>
                            <circle id="Oval" cx="53" cy="37" r="1"/>
                            <circle id="Oval" cx="53" cy="40" r="1"/>
                            <circle id="Oval" cx="53" cy="43" r="1"/>
                            <path
                              d="M26,53 L34,53 C34.5522847,53 35,52.5522847 35,52 C35,51.4477153 34.5522847,51 34,51 L26,51 C25.4477153,51 25,51.4477153 25,52 C25,52.5522847 25.4477153,53 26,53 Z"
                              id="Shape"/>
                            <path
                              d="M36,54 L24,54 C23.4477153,54 23,54.4477153 23,55 C23,55.5522847 23.4477153,56 24,56 L36,56 C36.5522847,56 37,55.5522847 37,55 C37,54.4477153 36.5522847,54 36,54 Z"
                              id="Shape"/>
                            <path
                              d="M5,30 C5.55228475,30 6,29.5522847 6,29 L6,28 C6,27.4477153 5.55228475,27 5,27 C4.44771525,27 4,27.4477153 4,28 L4,29 C4,29.5522847 4.44771525,30 5,30 Z"
                              id="Shape"/>
                            <path
                              d="M5,40 C5.55228475,40 6,39.5522847 6,39 L6,33 C6,32.4477153 5.55228475,32 5,32 C4.44771525,32 4,32.4477153 4,33 L4,39 C4,39.5522847 4.44771525,40 5,40 Z"
                              id="Shape"/>
                          </g>
                        </g>
                      </svg>
                      Print
                    </button>
                  </div>
                </div>
                <div class="inner-box mt-4" *ngFor="let n of checkedListView">
                  <div calss="row">
                    <div calss="col">
                      <div class="row">
                        <div class="col-md-2">
                          <ngx-barcode [bc-value]="n.codeValue" [bc-display-value]="true"></ngx-barcode>
                        </div>
                      </div>
                      <label class="text-black"><b>Tote Id : </b>{{n.toteId}}</label><br>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
-->
